import * as React from "react";
import { ReactElement } from "react";
import { Button } from "@mantine/core";

type ActionButtonProps = {
    icon: ReactElement;
    label?: string | null;
    onClick?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    href?: string | null;
    variant?: "primary" | "secondary" | "clean";
} & Omit<React.ComponentPropsWithoutRef<typeof Button>, "leftSection" | "variant" | "onClick" | "href">;

const variantMap = {
    primary: "light",
    secondary: "default",
    clean: "subtle",
} as const;

export const ActionButton = ({
    icon,
    label = null,
    href = null,
    onClick,
    variant = "primary",
    ...props
}: ActionButtonProps): ReactElement => {
    const sharedProps = {
        leftSection: icon,
        size: "compact-sm" as const,
        variant: variantMap[variant],
        ...props,
    };

    if (href) {
        return (
            <Button component="a" href={href} {...sharedProps}>
                {label}
            </Button>
        );
    }

    return (
        <Button type="button" onClick={onClick} {...sharedProps}>
            {label}
        </Button>
    );
};
